import { useSearchParams } from 'react-router-dom';
import img1 from '../assets/images/card1.png';
import img2 from '../assets/images/card2.png';
import img3 from '../assets/images/card3.png';
import BottomNav from '../components/mobile/BottomNav';
import { useTranslations } from '../hooks/useTranslations';
import { useAuth } from '../contexts/AuthContext';

const COURSE_URLS = {
    silver: 'https://maxprofitacademy.com/courses/begginer.html',
    gold: 'https://maxprofitacademy.com/courses/medium.html',
    platinum: 'https://maxprofitacademy.com/courses/pro.html'
};

function Activate() {
    const [, setSearchParams] = useSearchParams();
    const { t } = useTranslations();
    const { data: userData } = useAuth();

    // Определяем базовые цены в зависимости от наличия активированного кода
    const hasCode = userData?.code && userData.code.trim() !== '';
    const hasPromotion = userData?.promotion === true;
    
    // Базовые цены курсов
    const defaultPrices = {
        silver: 100,
        gold: 250,
        platinum: 500
    };
    
    // Цены при активированном коде
    const codePrices = {
        silver: 100,
        gold: 250,
        platinum: 500
    };
    
    // Функция для расчета финальной цены
    const calculatePrice = (basePrice, codePrice) => {
        // Если есть код - используем цены с кодом
        let price = hasCode ? codePrice : basePrice;
        
        // Если есть promotion, применяем -50% поверх текущей цены
        if (hasPromotion) {
            price = Math.round(price * 0.5);
        }
        
        return price;
    };
    
    const plans = [
        {
            id: 'silver',
            name: 'SILVER',
            price: calculatePrice(defaultPrices.silver, codePrices.silver),
            // Для зачеркнутой цены показываем цену до применения promotion
            defaultPrice: hasCode && !hasPromotion ? defaultPrices.silver : (hasPromotion ? (hasCode ? codePrices.silver : defaultPrices.silver) : defaultPrices.silver),
            icon: img1,
            description: t('activate.silverDescription'),
            hasDiscount: hasCode || hasPromotion
        },
        {
            id: 'gold',
            name: 'GOLD',
            price: calculatePrice(defaultPrices.gold, codePrices.gold),
            defaultPrice: hasCode && !hasPromotion ? defaultPrices.gold : (hasPromotion ? (hasCode ? codePrices.gold : defaultPrices.gold) : defaultPrices.gold),
            icon: img2,
            description: t('activate.goldDescription'),
            isHot: true,
            hasDiscount: hasCode || hasPromotion
        },
        {
            id: 'platinum',
            name: 'PLATINUM',
            price: calculatePrice(defaultPrices.platinum, codePrices.platinum),
            defaultPrice: hasCode && !hasPromotion ? defaultPrices.platinum : (hasPromotion ? (hasCode ? codePrices.platinum : defaultPrices.platinum) : defaultPrices.platinum),
            icon: img3,
            description: t('activate.platinumDescription'),
            hasDiscount: hasCode || hasPromotion
        }
    ];

    const handlePayment = (plan) => {
        // Передаем скидочную цену
        setSearchParams({ course: plan.id, price: plan.price });
    };

    return (
        <div className="container mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {plans.map((plan) => (
                    <div 
                        key={plan.id}
                        className="bg-white rounded-[20px] p-6 relative"
                    >
                        {plan.isHot && (
                            <div className="absolute -top-2 right-4 bg-red-500 text-white text-xs px-2 py-1 rounded-full">
                                {t('activate.popular')}
                            </div>
                        )}
                        
                        <div className="flex justify-between items-start mb-4">
                            <div>
                                <h3 className="text-gray-400 mb-8 text-sm">{plan.name}</h3>
                                <div className="flex flex-col">
                                    {/* Показываем зачеркнутую старую цену только если есть реальная скидка */}
                                    {plan.hasDiscount && plan.defaultPrice !== plan.price && (
                                        <span className="text-lg line-through text-gray-400">${plan.defaultPrice}</span>
                                    )}
                                    <div className="flex items-baseline gap-2">
                                        {/* Показываем -50% если есть promotion */}
                                        {hasPromotion && (
                                            <span className="text-xs text-red-500 font-semibold">-50%</span>
                                        )}
                                        <div className="text-3xl font-bold mt-1">${plan.price}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="w-24 h-24 flex items-center justify-center">
                                <img src={plan.icon} alt={plan.name} className="w-full h-full object-contain" />
                            </div>
                        </div>

                        <p className="text-sm text-gray-600 mb-6 min-h-[60px]">
                            {plan.description}
                        </p>

                        <div className="grid grid-cols-2 gap-2">
                            <button
                                onClick={() => handlePayment(plan)}
                                className="flex-1 text-[14px] md:text-[18px] bg-primary text-black font-medium py-2 px-4 rounded-full hover:bg-primary/90 transition-colors"
                            >
                                {t('activate.topUp')}
                            </button>
                            <button
                                onClick={() => window.open(COURSE_URLS[plan.id], '_blank')}
                                className="text-gray-600 hover:text-gray-900 transition-colors text-[14px] md:text-[18px]"
                            >
                                {t('activate.learnMore')}
                            </button>
                        </div>
                    </div>
                ))}
            </div>
            <BottomNav />
        </div>
    );
}

export default Activate; 